import axios from "axios";
import { apiPath } from "./apiPath"; // Assuming you have this file for API_URL
import { showApiErrorToast } from "./toastErrorHandler";

// 1. Create the Axios Instance
const api = axios.create({
  baseURL: apiPath.API_URL || "http://localhost:9000/api/v1", // Fallback if apiPath is missing
  headers: {
    "Content-Type": "application/json",
  },
});

// 2. Request Interceptor (Attaches Token to every request)
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage (or Redux store if you prefer)
    const token = localStorage.getItem("token");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 3. Response Interceptor (Global Error Handling)
api.interceptors.response.use(
  (response) => {
    // Return the response directly if success
    return response;
  },
  (error) => {

    // Handle specific error codes globally
    if (error.response && error.response.status === 401) {
      // Token expired or invalid
      console.error(error.response, "Session expired. Logging out...");

      // Optional: Clear storage and redirect to login
      // showApiErrorToast(error.response.message);
      localStorage.removeItem("token");
      // window.location.href = "/login"; // Force redirect if needed
    }

    // Pass the error back to the specific API call (so your thunk can catch it)
    return Promise.reject(error);
  },
);

export default api;
